import { render } from "./ContractProposalSinglePage.vue?vue&type=template&id=a0f80966&scoped=true"
import script from "./ContractProposalSinglePage.vue?vue&type=script&lang=js"
export * from "./ContractProposalSinglePage.vue?vue&type=script&lang=js"

import "./ContractProposalSinglePage.vue?vue&type=style&index=0&id=a0f80966&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f80966"]])

export default __exports__